import { useState, useEffect } from 'react';
import { _AircraftCargo } from '../../../../core/services/dataBean/EntityCatalog';
import useDataBean from '../../../../core/services/dataBean/useDataBean';
import usePaginator from '../../../theme/Component/usePaginator';
import useModal, { MODAL_XL } from '../../../theme/Component/hooks/useModal';
import { toast } from 'react-toastify';
import { Modal } from '../../../theme/Component/Modal';
import { BasicTable } from '../../../theme/Component/BasicTable';



interface Props {
    idSelector: number;
    onChange: any;
    label?: string;
    returnType?: "ID" | "Object";
    render?: string;
}

type propsForm = {
    CallSign: string;
}

export const EditorAircraft = ({ idSelector, onChange, label, returnType = "ID", render }: Props) => {

    const { instance, lista, setLista, getLista } = useDataBean(_AircraftCargo)

    const [id, setID] = useState(null);
    const [text, setText] = useState<string>("")

    const [form, setForm] = useState<Partial<propsForm>>({});

    const modal = useModal("Aeronaves Disponibles", MODAL_XL);

    useEffect(() => {
        setID(idSelector)
    }, [idSelector])

    useEffect(() => {
        if (render) {
            setText(render)
        }
    }, [render])

    useEffect(() => {
        traerLista();
    }, [])

    const setValue = (e: string) => {
        const selectedId = parseInt(e);
        setID(selectedId);
        if (onChange) {
            const selectedItem = lista.find(
                (item) => item?.DataBeanProperties?.IDAircraftCargo == e
            );
            if (selectedItem) {
                onChange(returnType === "Object" ? selectedItem?.DataBeanProperties : selectedId);
                modal.close();
                setText(`${selectedItem.DataBeanProperties.AircraftCode} - ${selectedItem.DataBeanProperties.Name}`)
            } else {
                onChange(returnType === "Object" ? {} : null);
                toast.error("Vuelo no valido");
            }
        }
    };

    const traerLista = () => {
        getLista({ State: 1 }, null).then(
            (resp: any) => {
                if (resp) {
                    setLista(resp);
                }
            }
        ).catch(err => { toast.error(err) })
    }

    const head = [
        { title: 'ID', property: 'IDAircraftCargo', visible: true },
        { title: 'Código', property: 'AircraftCode', visible: true },
        { title: 'Nombre', property: 'Name', visible: true },
        { title: 'Max Peso Kg', property: 'MaxPayloadKg', visible: true },
        { title: 'Max Volume', property: 'MaxVolume', visible: true },
        { title: 'Actualizada', property: 'LastUpdate', visible: true }
    ]

    return (
        <>
            <label>{label ?? "Aeronaves Disponibles"}</label>
            <span className='form-control cursor ifmodal' onClick={() => modal.open()}>{text.trim() ? text : "Seleccione una Aeronave "}</span>
            <Modal modal={modal.modal} updateModal={modal.setModal}>
                <div className="row">
                    <div className="col-md-12">
                        <BasicTable head={head} body={lista} rowSet={(e) => { setValue(e.IDAircraftCargo); }} ></BasicTable>
                    </div>
                </div>

            </Modal>
        </>
    )
}